const ProjectContracts: React.FC = () => {
  // const contracts = [
  //   { title: '设计合作协议书', url: 'https://km.thape.com.cn:8022/preview.html?fileid=4081963', },
  //   { title: '人防设计合同', url: 'https://km.thape.com.cn:8022/preview.html?fileid=4081964', },
  //   { title: '幕墙合同', url: 'https://km.thape.com.cn:8022/#doc/enterprise/8052779', },
  //   { title: '智能化深化设计合同', url: 'https://km.thape.com.cn:8022/preview.html?fileid=4081965', },
  //   { title: '基坑围护设计合同', url: 'https://km.thape.com.cn:8022/preview.html?fileid=4081966', },
  //   { title: '灯光照明设计合同', url: 'https://km.thape.com.cn:8022/preview.html?fileid=4081967', },
  //   { title: '标识设计合同', url: 'https://km.thape.com.cn:8022/preview.html?fileid=4081968', },
  // ];
  const contracts = [
    {
      title: (<div>
        项目操作手册
        <div>规定</div>
      </div>), url: 'https://km.thape.com.cn:8022/#doc/enterprise/4347261',
    },
    {
      title: (<div>
        项目操作手册
        <div>指南及范例</div>
      </div>), url: 'https://km.thape.com.cn:8022/#doc/enterprise/4347263',
    },
    { title: (<div>
        项目操作手册
        <div>执行表单</div>
      </div>), url: 'https://km.thape.com.cn:8022/#doc/enterprise/4347262', isTemplate: true },
    {
      title: (<div>
        设计类分包
        <div>合同模板</div>
      </div>), url: 'https://km.thape.com.cn:8022/#doc/enterprise/8343491', isTemplate: true },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-2 md:gap-4 lg:gap-6 xl:gap-8 2xl:gap-12">
      {contracts.map((item, i) => (
        <a key={i} href={item.url} target="_blank" rel="noreferrer">
          <div className={`flex justify-center items-center w-full aspect-5/4 p-4 rounded-lg text-center text-lg font-bold ${item.isTemplate ? 'bg-orange-100 text-gray-600 hover:bg-orange-400 hover:text-white' : 'bg-gray-100 text-gray-600 hover:bg-dark-bg hover:text-white'}`}>
            {item.title}
          </div>
        </a>
      ))}
    </div>
  );
};

export default ProjectContracts;
